import { Box, Flex } from '@mantine/core';
import { Button, Text } from '@repo/foundations';
import { ImportStep } from '../types';

interface FooterButtonsProps {
	currentStep: ImportStep;
	isLoading: boolean;
	canImport: boolean;
	canNext: boolean;
	onNext: () => void;
	onBack: () => void;
	onCancel: () => void;
	onImport: () => void;
	showRetrievingData?: boolean;
}

export function FooterButtons({
	currentStep,
	isLoading,
	canImport,
	canNext,
	onNext,
	onCancel,
	onImport,
	showRetrievingData,
}: FooterButtonsProps) {
	return (
		<Flex justify="space-between" pt="md">
			<Box />

			<Flex align="center" gap="xs">
				{showRetrievingData && (
					<Text size="sm" color="text/secondary/default" mr="sm">
						Retrieving Data...
					</Text>
				)}
				<Button variant="default" onClick={onCancel} disabled={isLoading}>
					Cancel
				</Button>
				{currentStep === ImportStep.CREDENTIALS && (
					<Button
						variant="primary"
						onClick={onNext}
						disabled={isLoading || !canNext}
						loading={isLoading}
					>
						Next
					</Button>
				)}
				{currentStep === ImportStep.MONITOR_SELECTION && (
					<Button
						variant="primary"
						onClick={onImport}
						disabled={isLoading || !canImport}
						loading={isLoading}
					>
						Import
					</Button>
				)}
			</Flex>
		</Flex>
	);
}
